import React from 'react';
import PropTypes from 'prop-types';
import { LoadingLocalTakeover } from 'web-ui-components/lib/organisms/takeovers';

import PickerPage from './PickerPage';
import accountPropTypes from '../../../states/accounts/propTypes';
import PickerPagingContent, { contentPropTypes } from './PickerPaging.content';
import withContent from '../../../containers/withContent';
import PagingControl from './PagingControl';
import { Retry } from '../../../sharedComponents/Retry/Retry';
import { payeePropTypes } from '../../../sharedComponents/FromToPayeeSelector/propTypes';
import PickerMessage from './PickerMessage';

const PickerPagingView = ({
	pageLoading,
	currentPage,
	totalNumberOfPages,
	onPageChange,
	listViewSelected,
	accounts,
	numberOfFavourites,
	onFavouriteIconClick,
	onAccountClick,
	onRetry,
	content,
	error,
	accountsNeverFetched,
	layoutType,
	payees,
	showPayees,
	handlePayeeSelect,
	getIsPayeeSelected,
	isManageYourPayee,
	handleViewPayee,
	handleDeletePayee,
	handleEditPayee,
	handleEditChaps,
	payeesNeverFetched,
	getIsAccountSelected,
	isBootStrapInProgress,
}) => {
	if (error) {
		return <Retry onRetry={onRetry} message={content.errorMessage} buttonText={content.retry} />;
	}
	return (
		<div data-test-id="account-picker-paging-view">
			<PickerMessage
				numberOfFavourites={numberOfFavourites}
				content={content}
				accounts={accounts}
				accountsNeverFetched={accountsNeverFetched}
				layoutType={layoutType}
				payees={payees}
				pageLoading={pageLoading}
				payeesNeverFetched={payeesNeverFetched}
				showPayees={showPayees}
				isManageYourPayee={isManageYourPayee}
			/>
			<PagingControl currentPage={currentPage} totalNumberOfPages={totalNumberOfPages} onPageChange={onPageChange} />
			<div className="account-picker__itemscontainer">
				<LoadingLocalTakeover show={!isBootStrapInProgress && pageLoading} title="Loading">
					<PickerPage
						accounts={accounts}
						listViewSelected={listViewSelected}
						onFavouriteIconClick={onFavouriteIconClick}
						onAccountClick={onAccountClick}
						payees={payees}
						layoutType={layoutType}
						showPayees={showPayees}
						handlePayeeSelect={handlePayeeSelect}
						getIsPayeeSelected={getIsPayeeSelected}
						getIsAccountSelected={getIsAccountSelected}
						isManageYourPayee={isManageYourPayee}
						handleViewPayee={handleViewPayee}
						handleDeletePayee={handleDeletePayee}
						handleEditPayee={handleEditPayee}
						handleEditChaps={handleEditChaps}
					/>
				</LoadingLocalTakeover>
			</div>

			<PagingControl currentPage={currentPage} totalNumberOfPages={totalNumberOfPages} onPageChange={onPageChange} />
		</div>
	);
};

PickerPagingView.defaultProps = {
	isBootStrapInProgress: false,
	payees: [],
	accounts: [],
};

PickerPagingView.propTypes = {
	pageLoading: PropTypes.bool.isRequired,
	currentPage: PropTypes.number.isRequired,
	totalNumberOfPages: PropTypes.number.isRequired,
	onPageChange: PropTypes.func.isRequired,
	listViewSelected: PropTypes.bool.isRequired,
	accounts: PropTypes.arrayOf(PropTypes.shape(accountPropTypes).isRequired),
	content: PropTypes.shape(contentPropTypes),
	onAccountClick: PropTypes.func,
	onFavouriteIconClick: PropTypes.func.isRequired,
	error: PropTypes.bool.isRequired,
	onRetry: PropTypes.func.isRequired,
	accountsNeverFetched: PropTypes.bool.isRequired,
	numberOfFavourites: PropTypes.number,
	layoutType: PropTypes.string.isRequired,
	showPayees: PropTypes.bool.isRequired,
	payees: PropTypes.arrayOf(PropTypes.shape(payeePropTypes)),
	handlePayeeSelect: PropTypes.func,
	getIsPayeeSelected: PropTypes.func,
	isManageYourPayee: PropTypes.bool,
	payeesNeverFetched: PropTypes.bool,
	handleViewPayee: PropTypes.func,
	handleDeletePayee: PropTypes.func,
	handleEditPayee: PropTypes.func,
	getIsAccountSelected: PropTypes.func,
	isBootStrapInProgress: PropTypes.bool,
};

export default withContent({ content: PickerPagingContent })(PickerPagingView);
